<template>
  <div>
    <courseRepair ref="courseRepair"></courseRepair>
  </div>
</template>

<script>
import courseRepair from '@/views/v4ward/gateservice/order-list/order-list/course-repair'; //报修服务
import { getOrderDetail } from '@/api/gateservice/order/order';

export default {
  name: 'orderDetail',
  props: ['orderId'],
  components: {
    courseRepair,
  },
  data() {
    return {
      orderDetail: null, // 工单详情
    };
  },
  methods: {
    show() {
      getOrderDetail({
        orderId: this.orderId,
      }).then(({ data }) => {
        this.orderDetail = data.orderDetails[0];
        this.openCourse(this.orderDetail, 'detail');
      });
    },
    openCourse(row, type) {
      setTimeout(() => {
        this.$refs.courseRepair.getDictionary(row).then(() => {
          if (type == 'edit') {
            this.$refs.courseRepair.openDialog(row, true);
          } else {
            this.$refs.courseRepair.openDialog(row, false);
          }
        });
      });
      return;
    },
  },
};
</script>

<style>
</style>